import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { ExercisesDefault } from './Default';
import { ExercisesQuestionsDefault } from './Default/ExercisesQuestionsDefault';
import ExercisesPlayful from './Playful';
import ExercisesQuestionsPlayful from './Playful/ExercisesQuestions';

function Exercises(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  return isPlayfulStudentTheme ? <ExercisesPlayful {...props} /> : <ExercisesDefault {...props} />;
}

function ExercisesQuestions(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  return isPlayfulStudentTheme ? <ExercisesQuestionsPlayful {...props} /> : <ExercisesQuestionsDefault {...props} />;
}

export { Exercises, ExercisesQuestions };
